export class CustomerCart {
  constructor(data) {
    if (data?.length && data[0]) {
      this.cartId = data[0].id || '';
      this.entries = data[0].entries || '';
    }
  }
}
